/**
 * Created by Omar Alejandro Leonor Avalos
 */
import Menu from './menu';
import Logout from './logout';
import Confirmation from './confirmation';

export {
    Menu,
    Logout,
    Confirmation
};



// WEBPACK FOOTER //
// ./modals/index.js